import { motion } from "framer-motion";
import RoadAheadCard from "@/components/RoadAheadCard";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const GraduationCard = ({ graduationData, setGraduationData, handleReturn, sessionId }) => {
  if (!graduationData) return null;

  const handleShareWisdom = async () => {
    await fetch(`${API}/community-wisdom/share`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ session_id: sessionId, tier_name: graduationData.completed_tier })
    });
    setGraduationData(prev => ({ ...prev, ask_community_share: false, shared: true }));
  };

  const isFinalTier = graduationData.new_tier === graduationData.completed_tier;

  return (
    <motion.div initial={{ opacity: 0, scale: 0.9 }} animate={{ opacity: 1, scale: 1 }}
      className="p-5 rounded-2xl text-center" style={{ backgroundColor: '#FFF8E7', border: '2px solid #D4A574' }}
      data-testid="graduation-card">
      <div className="text-3xl mb-2">&#x1F955;</div>
      <div className="text-lg font-bold mb-1" style={{ color: '#4F378B', fontFamily: "'Fredoka', sans-serif" }}>
        Tier Complete: {graduationData.completed_tier}
      </div>
      <div className="text-xs mb-3" style={{ color: '#D4A574', fontWeight: 700 }}>+1 Carrot Earned</div>

      {/* Garment Unlocked */}
      {graduationData.garment_unlocked && (
        <div className="p-3 rounded-xl mb-3" style={{ backgroundColor: '#F0E8F8', border: '1px solid #D8CCE8' }}>
          <div className="text-2xl mb-1">{graduationData.garment_unlocked.emoji}</div>
          <div className="text-xs font-bold" style={{ color: '#4F378B' }}>Garment Unlocked: {graduationData.garment_unlocked.name}</div>
          <div className="text-[10px]" style={{ color: '#8B7DA8' }}>{graduationData.garment_unlocked.desc}</div>
        </div>
      )}

      <div className="text-left mb-3">
        <div className="text-xs font-bold mb-2" style={{ color: '#4F378B' }}>Your 5 Key Insights:</div>
        {graduationData.insights.map((insight, i) => (
          <div key={`insight-${insight.substring(0,20)}-${i}`} className="text-xs mb-1 pl-3" style={{ color: '#5C5470', borderLeft: '2px solid #D4A574' }}>{insight}</div>
        ))}
      </div>

      {/* Next Tier Preview — small, evocative, no spoilers */}
      {!isFinalTier && (
        <div className="mb-3">
          <RoadAheadCard nextTierName={graduationData.new_tier} variant="compact" />
        </div>
      )}

      {graduationData.ask_community_share && (
        <button onClick={handleShareWisdom}
          className="px-5 py-2 rounded-full text-xs font-semibold mb-3 mr-2"
          style={{ backgroundColor: '#E8F5E8', color: '#2E7D32', border: '1px solid #4CAF50' }}
          data-testid="share-wisdom-button">
          Share wisdom with community
        </button>
      )}
      {graduationData.shared && (
        <div className="text-xs mb-3" style={{ color: '#4CAF50' }}>Shared with the community!</div>
      )}

      <button onClick={handleReturn} className="px-6 py-2 rounded-full text-sm font-semibold text-white"
        style={{ background: 'linear-gradient(135deg, #D4A574, #4F378B)' }} data-testid="continue-after-graduation">
        Enter {graduationData.new_tier} Tier
      </button>
    </motion.div>
  );
};

export default GraduationCard;
